export default __webpack_public_path__ + "static/media/avatar_94.6e35fd43.png";